module.exports = __webpack_public_path__ + "static/logo-white-71c541f9dd28810b4ba6b098f623f023.svg";